import { IRoleType, IUserDetails } from '../services/user-details/user-details.model';

// Single role gate for nav components and route guards. Previously copy-pasted in five places,
// which is exactly how one navbar misses a new role literal.
export function userHasRequiredRole(userDetails: IUserDetails | undefined | null, allowedRoles?: IRoleType[]): boolean {
  if (!userDetails?.roles) return false;
  if (!allowedRoles || allowedRoles.length === 0) return false;
  return userDetails.roles.some((role) => allowedRoles.includes(role));
}

// True when the session is limited to specific locations/subsidiaries (BE read-scoping active).
export function isEntityScoped(userDetails: IUserDetails | undefined | null): boolean {
  const scope = userDetails?.entityScope;
  if (!scope) return false;
  return !scope.accessAllLocations || !scope.accessAllSubsidiaries;
}
